<template>
  <div>
    <!--
          给editor加key是因为给tinymce keep-alive以后组件切换时tinymce编辑器会显示异常，
          在activated钩子里改变key的值可以让编辑器重新创建
    -->
    <editor
      id="tinymceEditor"
      :init="tinymceInit"
      v-model="content"
      :key="tinymceFlag"
    ></editor>
    <a-upload-dragger
      accept="image/*"
      name="file"
      :headers="headers"
      :beforeUpload="beforeUpload"
      style="display:none;"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" id="imageUpload" />
      </p>
      <p class="ant-upload-text">点击上传图片</p>
    </a-upload-dragger>

    <a-upload-dragger
      accept=".zip,.rar"
      name="file"
      :headers="headers"
      :beforeUpload="attachChange"
      style="display:none;"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" id="attachUpload" />
      </p>
      <p class="ant-upload-text">点击上传附件</p>
    </a-upload-dragger>
    <!--<input type="file" style="display: none" ref="imageUpload" @change="doUpload">-->
    <!--<Upload-->
    <!--multiple-->
    <!--ref="imageUpload"-->
    <!--action="//jsonplaceholder.typicode.com/posts/"-->
    <!--:on-success="insertImage"-->
    <!--style="display:none">-->
    <!--</Upload>-->
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/icons/default';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/table';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/code';
export default {
  name: 'TinymceEditor',
  components: {
    editor: Editor
  },
  props: ['detail', 'height'],
  watch: {
    content() {
      // 监听子组件的变化
      let imgArr = [];
      this.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/gi,
        (match, capture) => {
          if (
            capture.indexOf('mediacdn.cn3x.com.cn') == -1 &&
            capture.indexOf('img.cn3x.com.cn') == -1 &&
            capture.indexOf('ycrmt.cn') == -1 &&
            capture.indexOf('http') > -1
          ) {
            imgArr.push(capture);
          }
        }
      );
      if (imgArr.length > 0) {
        // 方正图片路径hack
        if (imgArr[0].slice(-6) == '.jpg.1') {
          imgArr[0] = imgArr[0].replace(/\.jpg\.1/, '.jpg');
        }
        let siteinfo = new Object();
        if (window.localStorage.getItem('siteinfo')) {
          siteinfo = JSON.parse(window.localStorage.getItem('siteinfo'));
        } else {
          this.$message.error('错误，请重试');
          return;
        }
        this.$http
          .post('https://openapi.ycrmt.cn/aliyun/index/urlImgesupload', {
            imgurl: imgArr[0],
            area_id: siteinfo.area_id,
            dept_id: siteinfo.dept_id,
            user_id: siteinfo.userid
          })
          .then(res => {
            if (res.data.errno == 0) {
              this.content = this.content
                .replace(imgArr[0], res.data.data.url + '/thumb_800')
                .replace('/thumb_800.1', '/thumb_800');
              if (typeof res.data.data.url != 'undefined') {
                this.coverArr.push(res.data.data.url);
              }
            }
          });
      }
      // console.log(this.coverArr)
      // if (imgArr.length > 0)  this.$message.success('远程图片保存成功');
      this.$emit('getEditorDetail', {
        content: this.content,
        imgArr: this.coverArr
      });
    },
    detail() {
      // 监听父组件的变化
      this.content = this.detail;
    }
  },
  data() {
    return {
      tinymceFlag: 1,
      tinymceInit: {},
      content: this.detail,
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      coverArr: []
    };
  },
  methods: {
    showModal() {
      console.log('modal');
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        let src = result.data.data;
        if (result.data.data.slice(-3) != 'gif') {
          src = src + '/thumb_800';
        }
        tinymce.execCommand(
          'mceInsertContent',
          false,
          `<p><img src=${src} style="max-width: 800px;"></p>`
        );
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    insertContent(data) {
      tinymce.execCommand('mceInsertContent', false, data);
    },
    async attachChange(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Fileupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        let src = result.data.data;
        tinymce.execCommand(
          'mceInsertContent',
          false,
          `<p>相关附件：<a href=${src} style="max-width: 800px;">${file.name}</a></p>`
        );
      } else {
        this.$$message.error('文件上传失败');
      }
    }
  },
  created() {
    const that = this;
    this.tinymceInit = {
      skin_url: '/tinymce/skins/ui/oxide',
      language_url: `/tinymce/langs/zh_CN.js`,
      content_css: '/tinymce/css/content.css',
      language: 'zh_CN',
      height: document.body.offsetHeight - 340,
      browser_spellcheck: true, // 拼写检查
      branding: false, // 去水印
      // elementpath: false,  //禁用编辑器底部的状态栏
      statusbar: false, // 隐藏编辑器底部的状态栏
      paste_data_images: true, // 允许粘贴图像
      menubar: false, // 隐藏最上方menu
      plugins: 'advlist table lists paste preview fullscreen code',
      external_plugins: {
        indent2em: `/tinymce/plugins/indent2em/plugin.min.js`,
        indent2em2: `/tinymce/plugins/indent2em/plugin.js`,
        divfloatright: `/tinymce/plugins/float/plugin.js`,
        divfloatleft: `/tinymce/plugins/float/plugin_left.js`,
        blackframe: `/tinymce/plugins/Blackframe/plugin.js`
      },
      // fontselect
      toolbar:
        'fontsizeselect forecolor backcolor bold italic' +
        ' underline  | alignleft aligncenter alignright | imageUpload ' +
        'testbutton videobutton audiobutton attachbutton quicklinkblockquote table ' +
        'numlist bullist fullscreen removeformat indent2em2 indent2em code divfloatleft divfloatright blackframe',
      /**
       * 下面方法是为tinymce添加自定义插入图片按钮
       * 借助iview的Upload组件,将图片先上传到存储云上，再将图片的存储地址放入编辑器内容
       */
      setup: editor => {
        editor.ui.registry.addButton('imageUpload', {
          // text: '插入图片',
          tooltip: '插入图片',
          icon: 'image',
          onAction: () => {
            // let upload = that.$refs.imageUpload;
            let upload = document.getElementById('imageUpload');
            upload.click();
          }
        });
        editor.ui.registry.addButton('testbutton', {
          // text: '插入图片',
          tooltip: '插入云图库图片',
          text:
            '<svg t="1561358039042" class="icon" viewBox="0 0 1170 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12576" width="22" height="22"><path d="M1170.212571 165.814857v691.931429c0 91.574857-69.851429 165.888-157.110857 165.888H151.771429C64.365714 1029.339429 0.438857 949.394286 0.438857 857.819429v-691.931429C0.438857 74.24 64.438857 0 151.771429 0H1013.028571c87.259429 0 157.110857 74.313143 157.110858 165.814857zM273.993143 263.094857c-40.740571 0-75.702857 34.304-75.702857 80.018286 0 45.787429 34.962286 85.796571 75.702857 85.796571 40.740571 0 75.629714-40.009143 75.629714-85.796571 5.851429-45.714286-29.110857-80.018286-75.629714-80.018286zM1042.139429 720.457143l-168.740572-383.122286c-5.851429-17.188571-17.481143-22.893714-34.889143-28.598857-17.554286-5.705143-29.110857 0-40.740571 11.410286L582.436571 537.6 448.585143 440.32c-17.481143-11.410286-46.592-11.410286-64.073143 5.705143L151.771429 703.414857c-11.702857 17.115429-17.481143 40.009143-11.702858 57.197714 5.851429 22.820571 23.332571 40.009143 40.813715 40.009143h814.738285c17.481143 0 34.889143-11.410286 40.740572-22.893714 11.629714-17.115429 11.629714-40.009143 5.851428-57.197714z" fill="#35A6FF" p-id="12577"></path></svg>',
          onAction: () => {
            this.$emit('showModal');
            // this.showModal()
          }
        });
        editor.ui.registry.addButton('videobutton', {
          // text: '插入图片',
          tooltip: '插入云视频',
          text:
            '<svg t="1561358085492" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13368" width="24" height="24"><path d="M250.944 350.28h367.368v347.168H250.944V350.28z" fill="#FFFFFF" p-id="13369"></path><path d="M945.464 256.568c-20.864-13.56-177.416 62.16-177.416 62.16v-7.872c-0.216-66.296-54.136-119.864-120.424-119.648H183.552c-66.296-0.216-120.208 53.344-120.432 119.64v402.296c0 66.152 53.888 119.704 120.432 119.704h464.064c66.296 0.208 120.208-53.352 120.432-119.648V703.304s157.504 75.152 177.416 62.272c19.968-12.88 20.864-495.504 0-509.008zM318.784 648.072V374.92l249.24 136.576-249.24 136.576z" fill="#F29A4C" p-id="13370"></path></svg>',
          onAction: () => {
            this.$emit('showVideo');
            // this.showModal()
          }
        });
        editor.ui.registry.addButton('audiobutton', {
          // text: '插入图片',
          tooltip: '插入音频',
          text:
            '<svg t="1561445038481" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1181" width="24" height="24"><path d="M174.3 63.9h542.3l184 210.3v637.1c0 26.7-21.7 48.4-48.4 48.4H174.3c-26.7 0-48.4-21.7-48.4-48.4v-799c-0.1-26.8 21.6-48.4 48.4-48.4z" fill="#777AEE" p-id="1182"></path><path d="M710.9 253.6l5-189.7 184.7 210.9-165.5 3c-13.3 0-24.2-10.9-24.2-24.2z" fill="#AFB0FF" p-id="1183"></path><path d="M689.1 475.4c-2.5-0.3-4.7-1.9-6.6-4.8-1.9-2.9-3.4-8.1-4.5-15.8-1.8-12.4-6.3-21.6-13.5-27.4-7.2-5.9-18.4-10.1-33.6-12.6-15.9-2.9-29.9-8.7-42-17.4-12.2-8.7-22.3-17-30.4-24.6-7.8-6.7-13.8-9.1-18-7.2-4.2 1.9-6.4 5.4-6.4 10.5v65.4c0 17.8-0.1 37.1-0.3 57.8-0.2 20.7-0.3 40.2-0.3 58.7v75.9c0.3 7.6-1 16.2-4 25.5-3 9.4-8.6 18.2-16.9 26.5-8.3 8.3-19.3 15.3-33.1 21.3-13.8 5.9-30.9 9.3-51.3 10.3-20.8 1-39.6-2.4-56.4-10-16.7-7.6-29.7-17.3-38.9-28.9-9.2-11.6-13.7-24.4-13.5-38.2 0.2-13.8 6.8-26.8 19.9-38.9 13.1-12.1 27.2-20.5 42.3-25.3 15.1-4.8 29.8-7.4 43.9-7.9 14.1-0.5 26.7 0.4 37.8 2.6 11.1 2.2 19.3 4.3 24.6 6.2V442c0-37.6 0.2-79.9 0.5-127 0-9.2 2.6-16.8 8-22.7 5.3-5.9 12.3-9.3 21.1-10.2 7.4-1 13.5 0.4 18.3 4.1 4.8 3.7 9.6 8.7 14.5 15.3 4.9 6.5 11 13.9 18.3 22.2 7.2 8.3 17 16.4 29.4 24.3 10.6 7.3 19.9 12.6 27.8 15.8 7.9 3.2 15.4 6.1 22.2 8.8 6.9 2.7 13.7 6 20.4 9.8 6.7 3.8 14.1 10 22.2 18.6 8.1 8.3 13.1 16.9 14.8 25.8 1.8 8.9 1.9 17 0.3 24.3-1.6 7.3-4.1 13.3-7.7 17.9-3.4 4.6-6.4 6.7-8.9 6.4z" fill="#FFFFFF" p-id="1184"></path></svg>',
          onAction: () => {
            this.$emit('showAudio');
            // this.showModal()
          }
        });
        editor.ui.registry.addButton('attachbutton', {
          // text: '插入图片',
          tooltip: '插入附件',
          text:
            '<svg t="1576221175256" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12090" width="20" height="20"><path d="M409.6 0v68.266667h-34.133333c-20.48 0-34.133333 13.653333-34.133334 34.133333s13.653333 34.133333 34.133334 34.133333H409.6v68.266667h-34.133333c-20.48 0-34.133333 13.653333-34.133334 34.133333s13.653333 34.133333 34.133334 34.133334H409.6v68.266666h-34.133333c-20.48 0-34.133333 13.653333-34.133334 34.133334s13.653333 34.133333 34.133334 34.133333H409.6v68.266667h-34.133333c-20.48 0-34.133333 13.653333-34.133334 34.133333s13.653333 34.133333 34.133334 34.133333h68.266666c20.48 0 34.133333-13.653333 34.133334-34.133333V477.866667h34.133333c20.48 0 34.133333-13.653333 34.133333-34.133334S532.48 409.6 512 409.6H477.866667V341.333333h34.133333c20.48 0 34.133333-13.653333 34.133333-34.133333S532.48 273.066667 512 273.066667H477.866667V204.8h34.133333c20.48 0 34.133333-13.653333 34.133333-34.133333S532.48 136.533333 512 136.533333H477.866667V0h204.8l273.066666 273.066667v614.4c0 75.093333-61.44 136.533333-136.533333 136.533333H204.8c-75.093333 0-136.533333-61.44-136.533333-136.533333V136.533333C68.266667 61.44 129.706667 0 204.8 0h204.8z m0 682.666667h68.266667v68.266666H409.6v-68.266666z m-34.133333-68.266667c-20.48 0-34.133333 13.653333-34.133334 34.133333v136.533334c0 20.48 13.653333 34.133333 34.133334 34.133333h136.533333c20.48 0 34.133333-13.653333 34.133333-34.133333v-136.533334c0-20.48-13.653333-34.133333-34.133333-34.133333h-136.533333z" fill="#777777" p-id="12091"></path><path d="M682.666667 0l273.066666 273.066667h-204.8c-40.96 0-68.266667-27.306667-68.266666-68.266667V0z" fill="#E0E0E0" opacity=".597" p-id="12092"></path></svg>',
          onAction: () => {
            // let upload = that.$refs.attachUpload;
            let upload = document.getElementById('attachUpload');
            upload.click();
          }
        });
      }
    };
  },
  activated() {
    this.tinymceFlag++;
  },
  mounted() {}
};
</script>
